import axios from "axios";
import {SerialApi} from "./const_api";

//subscribe
export function serial_query(data) {
    return axios.post(SerialApi.query, data);
}


export function serial_getBySerial(data) {
    return axios.get(SerialApi.getBySerial,{ params: data });
}



export function serial_getById(data) {
    return axios.get(SerialApi.getById,{ params: data });
}
